module.exports = __webpack_public_path__ + "static/media/total.591d572e.svg";